import React from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import gujaratiFont from '../resources/NotoSansGujarati';
import { formatDateDMY } from '../comman/config';

const OrderIngredientModal = ({
    showOrderModal,
    setShowOrderModal,
    ingredientList,
    clearItem,
    page
}) => {
    // If no ingredient list, return null
    if (!ingredientList) return null;

        // Determine if ingredientList is an array or single object
        const ingredients = Array.isArray(ingredientList)
        ? ingredientList
        : [ingredientList];

    const handleExportPDF = () => {
        if (ingredients.length === 0) return;

        // Create a new jsPDF instance
        const doc = new jsPDF();
        doc.addFont(gujaratiFont, 'Gujarati', 'normal');
        doc.setFont('Gujarati');

        // Use order_id from the first item in the list
        const orderNumber = ingredients[0].order_id || '-';
        doc.setFontSize(16);
        doc.text('Dairy Order', 105, 15, { align: 'center' });
        doc.setFontSize(12);
        doc.text(`Order No. : ${orderNumber}`, 105, 25, { align: 'center' });

        // Prepare table columns and rows
        const tableColumn = ['Ingredient', 'Meal Date', 'Litres/kgs', 'Crates'];
        const tableRows = ingredients.map(item => [
            item.ingredient || '-',
            formatDateDMY(item.date) || '-',
            item.order_qty || item.liters_kgs || '-',
            item.crates_qty || '-'
        ]);

        // Generate the table using jspdf-autotable
        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 35,
            styles: {
                fontSize: 10,
                cellPadding: 3,
                font: 'Gujarati'
            },
            headStyles: {
                fillColor: [41, 128, 185], // Blue header
                textColor: 255 // White text
            }
        });

        // Save the PDF
        doc.save(`dairy_order_${orderNumber}.pdf`);
    };

    const handleClose = () => {
        setShowOrderModal(false);
        clearItem();
    };

    if (!showOrderModal) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
            onClick={(e) => {
                if (e.target === e.currentTarget) handleClose();
            }}
        >
            <div
                className="bg-white rounded-lg shadow-xl w-full max-w-[600px] max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="p-4 sm:p-6">
                    <div className="mb-4 text-center font-semibold text-lg">
                        Order No. : {ingredients[0].order_id}
                    </div>

                    {/* Desktop Table View */}
                    <div className="hidden md:block">
                        <table className="w-full border-collapse mb-4">
                            <thead>
                                <tr>
                                    <th scope="col" className="px-2 py-1 border border-black text-center" rowSpan="2">Ingredient</th>
                                    <th scope="col" className="px-2 py-1 border border-black text-center" rowSpan="2">Meal Date</th>
                                    <th scope="col" className="px-2 py-1 border border-black text-center" colSpan="2">Order Qty</th>
                                </tr>
                                <tr>
                                    <th className="px-2 py-1 border border-black text-center">Liters/Kgs</th>
                                    <th className="px-2 py-1 border border-black text-center">Crates</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ingredients.map((item, index) => (
                                    <tr key={index}>
                                        <td className="border border-black p-2 text-center">{item.ingredient}</td>
                                        <td className="border border-black p-2 text-center">{formatDateDMY(item.date)}</td>
                                        <td className="border border-black p-2 text-center">{item.order_qty || '-'}</td>
                                        <td className="border border-black p-2 text-center">{item.crates_qty || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Mobile Card View */}
                    <div className="md:hidden mb-4">
                        <div className="space-y-3">
                            {ingredients.map((item, index) => (
                                <div key={index} className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                                    <div className="mb-3">
                                        <h3 className="font-semibold text-gray-900 text-lg">{item.ingredient}</h3>
                                        <p className="text-sm text-gray-600 mt-1">
                                            <span className="font-medium">Meal Date:</span> {formatDateDMY(item.date)}
                                        </p>
                                    </div>

                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="bg-white p-3 rounded border">
                                            <div className="text-xs font-medium text-gray-600 uppercase tracking-wide">
                                                Order Qty (Liters/Kgs)
                                            </div>
                                            <div className="mt-1 text-lg font-semibold text-gray-900">
                                                {item.order_qty || '-'}
                                            </div>
                                        </div>
                                        <div className="bg-white p-3 rounded border">
                                            <div className="text-xs font-medium text-gray-600 uppercase tracking-wide">
                                                Crates
                                            </div>
                                            <div className="mt-1 text-lg font-semibold text-gray-900">
                                                {item.crates_qty || '-'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-2">
                        <button
                            onClick={handleClose}
                            className="w-full sm:w-auto px-4 py-2 bg-gray-200 text-black rounded hover:bg-gray-300 transition-colors"
                        >
                            Close
                        </button>
                        <button
                            onClick={handleExportPDF}
                            className="w-full sm:w-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                        >
                            Export PDF
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderIngredientModal;